module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "overflow-y": "scroll",
      "height": "430px",
      "padding": "0 8px"
    },
    attrs: {
      "element-loading-background": "#F7F8FC"
    }
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('div', {
      key: campaign.title
    }, [_c('el-card', {
      staticStyle: {
        "height": "120px",
        "background-color": "#fff",
        "padding-bottom": "5px",
        "margin-bottom": "15px",
        "border": "none"
      },
      attrs: {
        "shadow": "hover"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block",
        "font-size": "1.2em",
        "font-weight": "bold",
        "color": "#000",
        "margin-bottom": "10px"
      }
    }, [_vm._v(_vm._s(campaign.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "font-weight": "light",
        "margin-bottom": "12px"
      }
    }, [_vm._v(_vm._s(campaign.type))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "font-weight": "light"
      }
    }, [_vm._v(_vm._s(campaign.date))])])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2003f51a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/profile/tabs/CampaignsTab.vue
// module id = 3176
// module chunks = 3